module.exports = __webpack_public_path__ + "static/media/1 medusa snake head chestpiece gothic architecture .1280x1707.987cc3e8.webp";